export interface ImportDateRange {
  startDate?: string;
  endDate?: string;
}

export const DEFAULT_IMPORT_SYNC_DAYS = 365;

const toISODate = (date: Date): string => date.toISOString().split('T')[0];

export const getDefaultImportDateRange = (days: number = DEFAULT_IMPORT_SYNC_DAYS): { startDate: string; endDate: string } => {
  const end = new Date();
  const start = new Date(end);
  start.setDate(end.getDate() - days);
  return {
    startDate: toISODate(start),
    endDate: toISODate(end),
  };
};

const parseDate = (value?: string): Date | null => {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const sanitizeImportDateRange = (range?: ImportDateRange): { startDate: string; endDate: string } => {
  const defaults = getDefaultImportDateRange();
  const providedEnd = parseDate(range?.endDate);
  const end = providedEnd ?? new Date(defaults.endDate);
  const providedStart = parseDate(range?.startDate);
  let start = providedStart ?? new Date(end);
  if (!providedStart) {
    start.setDate(end.getDate() - DEFAULT_IMPORT_SYNC_DAYS);
  }
  if (start > end) {
    start = new Date(end);
    start.setDate(end.getDate() - DEFAULT_IMPORT_SYNC_DAYS);
  }
  return {
    startDate: toISODate(start),
    endDate: toISODate(end),
  };
};

const isValidDate = (value?: string) => {
  if (value === undefined) return true;
  if (value === null) return false;
  const parsed = new Date(value);
  return !Number.isNaN(parsed.getTime());
};

export const getImportDateRangeError = (range?: ImportDateRange): string | null => {
  if (!range) return null;
  const { startDate, endDate } = range;
  if (startDate && !isValidDate(startDate)) {
    return 'Enter a valid start date.';
  }
  if (endDate && !isValidDate(endDate)) {
    return 'Enter a valid end date.';
  }
  if (startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start > end) {
      return 'Start date must be on or before the end date.';
    }
  }
  return null;
};
